import { render } from "./StudentAttend.vue?vue&type=template&id=f864ddb6&scoped=true"
import script from "./StudentAttend.vue?vue&type=script&lang=js"
export * from "./StudentAttend.vue?vue&type=script&lang=js"

import "./StudentAttend.vue?vue&type=style&index=0&id=f864ddb6&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f864ddb6"]])

export default __exports__